export default __webpack_public_path__ + "static/media/img-baf-03.cc28da6f.png";